if (!customElements.get('promocount-timer')) {
  class PromocountTimer extends HTMLElement {
    connectedCallback() {
      this.dateTo = new Date(this.dataset.dateTo).getTime();
      this.dateFrom = new Date(this.dataset.dateFrom).getTime();
      this.showDaysBefore = parseInt(this.dataset.showDaysBefore, 10) || 0;

      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      if (!this.isActive()) return;

      this.classList.add('promocount--active');
      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    isActive() {
      const now = Date.now();
      if (now < this.dateFrom || now > this.dateTo) return false;
      if (this.showDaysBefore > 0) {
        const daysLeft = (this.dateTo - now) / (1000 * 60 * 60 * 24);
        if (daysLeft > this.showDaysBefore) return false;
      }
      return true;
    }

    hide() {
      this.classList.remove('promocount--active');
      if (this.interval) clearInterval(this.interval);
    }

    update() {
      if (!this.isActive()) {
        this.hide();
        return;
      }

      const diff = this.dateTo - Date.now();

      if (diff <= 0) {
        this.hide();
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      this.daysEl.textContent = String(days).padStart(2, '0');
      this.hoursEl.textContent = String(hours).padStart(2, '0');
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
      this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('promocount-timer', PromocountTimer);
}
